module.exports = __webpack_public_path__ + "static/img/join.879aaf54.svg";